import React, { Component } from 'react'
import Leaflet from 'leaflet'
import { Marker } from 'react-leaflet'

export default class CustomIcons extends Component {
  render() {
    const purpleIcon = new Leaflet.Icon({
      iconUrl: require('../../static/icon-eight.png'),
      iconRetinaUrl: require('../../static/icon-seven.png'),
      iconAnchor: [15, 30],
      popupAnchor: [0, -30],
      iconSize: [30, 30],
      //shadowUrl: shadow,
      //shadowSize: [23, 20],
      //shadowAnchor: [4.5, 20],
    })/*
    const orangeIcon = new Leaflet.Icon({
      iconUrl: require('../../static/icon-six.png'),
      iconRetinaUrl: require('../../static/icon-five.png'),
      iconAnchor: [15, 30],
      popupAnchor: [0, -30],
      iconSize: [30, 30],
      //shadowUrl: shadow,
      //shadowSize: [23, 20],
      //shadowAnchor: [4.5, 20],
    })
    if (this.props.color === "purple") {
      return (
        <Marker position={this.props.position} icon={purpleIcon}>
          {this.props.children}
        </Marker>
        )
      } else {
        return (
        <Marker position={this.props.position} icon={orangeIcon}>
          {this.props.children}
        </Marker>
      )
    } */

    return (
      <Marker position={this.props.position} icon={purpleIcon}>
        {this.props.children}
      </Marker>
      )
  }
}